import React, { FC } from 'react';

import { Box, Checkbox, HStack, Text } from '@chakra-ui/react';

import { formatDate } from 'utils/date';

import { DataAccessFilters, describeCounts, SummaryCounts } from './utils';

interface DataAccessToolbarProps {
  filters: DataAccessFilters;
  counts: SummaryCounts;
  computedAt?: string | null;

  onChange(filters: Partial<DataAccessFilters>): void;
}

/**
 * The two filters, which apply at every level, and what they leave: "16
 * databases · 65 schemas · 3,900 tables", as of the last rollup.
 */
export const DataAccessToolbar: FC<DataAccessToolbarProps> = props => {
  const { filters, counts, computedAt, onChange } = props;
  return (
    <HStack justify="space-between" spacing={4} flexWrap="wrap">
      <HStack spacing={5}>
        <Checkbox
          isChecked={filters.highPrivilegeOnly}
          onChange={e => onChange({ highPrivilegeOnly: e.target.checked })}
          colorScheme="purple"
        >
          <Text>High privileges only</Text>
        </Checkbox>
        <Checkbox
          isChecked={filters.sensitiveOnly}
          onChange={e => onChange({ sensitiveOnly: e.target.checked })}
          colorScheme="purple"
        >
          <Text>Sensitive data only</Text>
        </Checkbox>
      </HStack>
      <Box fontSize="sm" color="gray.400">
        {describeCounts(counts)}
        {/* Database rows are as of the last rollup; drill-downs are live. */}
        {computedAt && ` · As of ${formatDate(computedAt)}`}
      </Box>
    </HStack>
  );
};
